import { useCallback, useState } from "react";
import { message } from "antd";
import { IndoorPositioningEquipment } from "../../../../api";

// Loads and refreshes the equipment list (with nested tags) for one machine.
// CRUD calls themselves stay in the components that trigger them (same split
// as PersonnelModal/BaseStationModal), this hook only owns the list state.
const useEquipment = (machineID) => {
  const [equipment, setEquipment] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadEquipment = useCallback(async () => {
    if (!machineID) return;
    setLoading(true);
    try {
      const response = await IndoorPositioningEquipment.GetEquipment(machineID);
      if (response.code === 200) {
        setEquipment(response.data || []);
      } else {
        message.error(response.message || "獲取機具定位器失敗");
      }
    } catch (error) {
      console.error("載入機具定位器失敗:", error);
      message.error("載入機具定位器失敗");
    } finally {
      setLoading(false);
    }
  }, [machineID]);

  return { equipment, loading, loadEquipment };
};

export default useEquipment;
